const cookieButtons = document.querySelectorAll('.js-manage-cookies');

cookieButtons?.forEach((button) => {
  button.addEventListener('click', (e) => {
    e.preventDefault();
    window.Cookiebot?.renew();
  });
});
